import {
  fetchElection,
  fetchQuestionnaire,
  fetchQuestionnaires,
  getQuestionnairesResults as getQuestionnairesResultsRequest,
  saveQuestionnairesResults as saveQuestionnairesResultsRequest,
  sendElectionAnswersRequest
} from '../api/questionnaires';
import { mergeResults } from '../utils/results-cache';

export const GET_QUESTIONNAIRES_FETCH = 'GET_QUESTIONNAIRES_FETCH';
export const GET_QUESTIONNAIRES_SUCCESS = 'GET_QUESTIONNAIRES_SUCCESS';
export const GET_QUESTIONNAIRES_FAIL = 'GET_QUESTIONNAIRES_FAIL';

export const GET_QUESTIONNAIRE_FETCH = 'GET_QUESTIONNAIRE_FETCH';
export const GET_QUESTIONNAIRE_SUCCESS = 'GET_QUESTIONNAIRE_SUCCESS';
export const GET_QUESTIONNAIRE_FAIL = 'GET_QUESTIONNAIRES_FAIL';

export const GET_ELECTION_FETCH = 'GET_ELECTION_FETCH';
export const GET_ELECTION_SUCCESS = 'GET_ELECTION_SUCCESS';
export const GET_ELECTION_FAIL = 'GET_ELECTION_FAIL';

export const REVERT_LAST_QUESTION = 'REVERT_LAST_QUESTION';
export const ADD_ANSWER = 'ADD_ANSWER';
export const CHANGE_ANSWER = 'CHANGE_ANSWER';
export const TOGGLE_ANSWER_LIKE = 'TOGGLE_ANSWER_LIKE';

export const SAVE_QUESTIONNAIRE_RESULTS_REQUEST = 'SAVE_QUESTIONNAIRE_RESULTS_REQUEST';
export const SAVE_QUESTIONNAIRE_RESULTS_SUCCESS = 'SAVE_QUESTIONNAIRE_RESULTS_SUCCESS';
export const SAVE_QUESTIONNAIRE_RESULTS_FAIL = 'SAVE_QUESTIONNAIRE_RESULTS_FAIL';

export const SAVE_ANSWERS_TO_HASH = 'SAVE_ANSWERS_TO_HASH';

export const SEND_ELECTION_ANSWERS_REQUEST = 'SEND_ELECTION_ANSWERS_REQUEST';
export const SEND_ELECTION_ANSWERS_SUCCESS = 'SEND_ELECTION_ANSWERS_SUCCESS';
export const SEND_ELECTION_ANSWERS_FAIL = 'SEND_ELECTION_ANSWERS_FAIL';

export const saveQuestionnairesResults = (questionnaireId, content) => async dispatch => {
  dispatch({ type: SAVE_QUESTIONNAIRE_RESULTS_REQUEST });
  try {
    const response = await saveQuestionnairesResultsRequest(questionnaireId, content);
    return dispatch({
      type: SAVE_QUESTIONNAIRE_RESULTS_SUCCESS,
      result: response.data.surveyResult
    });
  } catch (e) {
    dispatch({
      type: SAVE_QUESTIONNAIRE_RESULTS_FAIL,
      message: e
    });
  }
};

export const saveAnswersToHash = (hashId, answers) => async dispatch => {
  mergeResults(hashId, answers);
  dispatch({
    type: SAVE_ANSWERS_TO_HASH,
    hashId,
    answers
  });
};

export const sendElectionAnswers = (electionId, districtId, answers) => async dispatch => {
  dispatch({ type: SEND_ELECTION_ANSWERS_REQUEST });
  try {
    const response = await sendElectionAnswersRequest(electionId, districtId, answers);
    return dispatch({
      type: SEND_ELECTION_ANSWERS_SUCCESS,
      results: response
    });
  } catch (e) {
    dispatch({
      type: SEND_ELECTION_ANSWERS_FAIL,
      message: e
    });
  }
};

export const getQuestionnaires = () => async dispatch => {
  dispatch({ type: GET_QUESTIONNAIRES_FETCH });
  try {
    const { questionnaires, publishedDate } = await fetchQuestionnaires();
    dispatch({
      type: GET_QUESTIONNAIRES_SUCCESS,
      questionnaires,
      voteDate: publishedDate
    });
  } catch (e) {
    console.error(e);
    dispatch({
      type: GET_QUESTIONNAIRES_FAIL,
      message: e
    });
  }
};

export const getQuestionnaire = id => async dispatch => {
  dispatch({ type: GET_QUESTIONNAIRE_FETCH });
  try {
    const response = await fetchQuestionnaire(id);
    const questionnaire = response.data;
    dispatch({
      type: GET_QUESTIONNAIRE_SUCCESS,
      questionnaire
    });
  } catch (e) {
    console.error(e);
    dispatch({
      type: GET_QUESTIONNAIRE_FAIL,
      message: e
    });
  }
};

export const getElection = id => async dispatch => {
  dispatch({ type: GET_ELECTION_FETCH });
  try {
    const response = await fetchElection(id);
    const election = response.data;
    dispatch({
      type: GET_ELECTION_SUCCESS,
      election
    });
  } catch (e) {
    console.error(e);
    dispatch({
      type: GET_ELECTION_FAIL,
      message: e
    });
  }
};

export const changeAnswer = ({ questionnaireId, questionId, answer }) => async dispatch => {
  dispatch({
    type: CHANGE_ANSWER,
    questionnaireId,
    questionId,
    answer
  });
};

export const addAnswer = ({ questionnaireId, answer }) => async (dispatch, getState) => {
  const state = getState();
  const currentQuestionnaireMeta = state.voting.meta[questionnaireId];
  const currentQuestionnaires = state.voting.questionnaires[questionnaireId];
  const question = currentQuestionnaires.questions[currentQuestionnaireMeta.currentQuestion];
  if (currentQuestionnaires.questions.length <= currentQuestionnaireMeta.currentQuestion) {
    return;
  }
  await dispatch({
    type: ADD_ANSWER,
    questionId: question.id,
    questionnaireId,
    answer
  });
  currentQuestionnaires.questions.length === currentQuestionnaireMeta.currentQuestion + 1 &&
    dispatch(saveQuestionnairesResults(questionnaireId, currentQuestionnaireMeta));
};

export const toggleLike = ({ questionnaireId }) => async (dispatch, getState) => {
  const state = getState();
  const currentQuestionnaireMeta = state.voting.meta[questionnaireId];
  const currentQuestionnaires = state.voting.questionnaires[questionnaireId];
  const question = currentQuestionnaires.questions[currentQuestionnaireMeta.currentQuestion];
  dispatch({
    type: TOGGLE_ANSWER_LIKE,
    questionnaireId,
    questionId: question.id
  });
};

export const revertLastQuestion = ({ questionnaireId }) => async (dispatch, getState) => {
  const state = getState();
  const currentQuestionnaireMeta = state.voting.meta[questionnaireId];
  const currentQuestionnaires = state.voting.questionnaires[questionnaireId];
  const question = currentQuestionnaires.questions[currentQuestionnaireMeta.currentQuestion];
  dispatch({
    type: REVERT_LAST_QUESTION,
    questionnaireId,
    questionId: question.id
  });
};

export const GET_QUESTIONNAIRE_RESULTS_REQUEST = 'GET_QUESTIONNAIRE_RESULTS_REQUEST';
export const GET_QUESTIONNAIRE_RESULTS_SUCCESS = 'GET_QUESTIONNAIRE_RESULTS_SUCCESS';
export const GET_QUESTIONNAIRE_RESULTS_FAIL = 'GET_QUESTIONNAIRE_RESULTS_FAIL';

export const getQuestionnairesResults = () => async dispatch => {
  dispatch({ type: GET_QUESTIONNAIRE_RESULTS_REQUEST });
  try {
    const response = await getQuestionnairesResultsRequest();
    dispatch({
      type: GET_QUESTIONNAIRE_RESULTS_SUCCESS,
      results: response.data.surveyResults
    });
  } catch (e) {
    console.error(e);
    dispatch({
      type: GET_QUESTIONNAIRE_RESULTS_FAIL,
      message: e
    });
  }
};

export const CHANGE_PAST_QUESTIONNAIRE_ANSWER = 'CHANGE_PAST_QUESTIONNAIRE_ANSWER';

export const changePastQuestionnaireAnswer = ({ questionnaireId, questionId, answer }) => async dispatch => {
  dispatch({
    type: CHANGE_PAST_QUESTIONNAIRE_ANSWER,
    questionnaireId,
    questionId,
    answer
  });
};

export const changeLikeState = (questionnaireId, questionId) => async dispatch => {
  dispatch({
    type: TOGGLE_ANSWER_LIKE,
    questionnaireId,
    questionId
  });
};

export const CHANGE_PAST_QUESTIONNAIRE_LIKE_STATE = 'CHANGE_PAST_QUESTIONNAIRE_LIKE_STATE';

export const changePastQuestionnaireLikeState = ({ questionnaireId, questionId }) => async dispatch => {
  dispatch({
    type: CHANGE_PAST_QUESTIONNAIRE_LIKE_STATE,
    questionnaireId,
    questionId
  });
};
